import { BaseError, createErrorBuilder } from '@wix/public-editor-platform-errors';
export let EditorPlatformManifestServicesErrorCode = /*#__PURE__*/function (EditorPlatformManifestServicesErrorCode) {
  EditorPlatformManifestServicesErrorCode["Internal"] = "Internal";
  EditorPlatformManifestServicesErrorCode["LoadManifestFromCDNError"] = "LoadManifestFromCDNError";
  EditorPlatformManifestServicesErrorCode["ManifestUrlNotProvided"] = "ManifestUrlNotProvided";
  EditorPlatformManifestServicesErrorCode["ContextualManifestAlreadyRegistered"] = "ContextualManifestAlreadyRegistered";
  EditorPlatformManifestServicesErrorCode["ContextualManifestDoesNotExist"] = "ContextualManifestDoesNotExist";
  EditorPlatformManifestServicesErrorCode["ManifestResolvingError"] = "ManifestResolvingError";
  EditorPlatformManifestServicesErrorCode["EditorPointerIsNotResolved"] = "EditorPointerIsNotResolved";
  EditorPlatformManifestServicesErrorCode["LoadComponentPanelError"] = "LoadComponentPanelError";
  EditorPlatformManifestServicesErrorCode["ManifestComponentTypeMissing"] = "ManifestComponentTypeMissing";
  EditorPlatformManifestServicesErrorCode["DefaultValueResolving"] = "DefaultValueResolving";
  EditorPlatformManifestServicesErrorCode["ManifestQuery"] = "ManifestQuery";
  EditorPlatformManifestServicesErrorCode["ManifestContextBuild"] = "ManifestContextBuild";
  EditorPlatformManifestServicesErrorCode["ContextualManifestSelectorNotFound"] = "ContextualManifestSelectorNotFound";
  return EditorPlatformManifestServicesErrorCode;
}({});
class EditorPlatformManifestServicesError extends BaseError {
  constructor(message, code) {
    super(message, code, 'Editor Platform Manifest Services Error');
  }

  // TODO: should be base method
  withMultipleErrors(errors) {
    this.state = {
      ...this.state,
      errors: errors.map(error => error.message).join(', ')
    };
    return this;
  }
  withComponentType(componentType) {
    this.state = {
      ...this.state,
      componentType
    };
    return this;
  }
  withInnerElementPath(elementPath) {
    const innerElementPath = elementPath ? elementPath.join(' ') : '';
    this.state = {
      ...this.state,
      innerElementPath
    };
    return this;
  }
}
export const createEditorPlatformManifestServicesError = createErrorBuilder(EditorPlatformManifestServicesError);
//# sourceMappingURL=errors.js.map